
function InputLabel(props) 
{
	const { text } = props;
	return (
		<div style={{paddingBottom: 4, fontWeight: 'bold'}}>{text}</div>
	)
}

export default InputLabel;